import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "gd-user-details pt-gutter pb-gutter",
  id: "userDetails"
}
const _hoisted_2 = {
  key: 0,
  class: "mb-gutter"
}
const _hoisted_3 = {
  key: 0,
  class: "alert alert--error"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-alert" }, null, -1)
const _hoisted_5 = { class: "list-styled" }
const _hoisted_6 = {
  key: 1,
  class: "alert alert--error"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-alert" }, null, -1)
const _hoisted_8 = { key: 1 }
const _hoisted_9 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_usercontactdetails = _resolveComponent("v-usercontactdetails")!
  const _component_v_usercontactdetailsv2 = _resolveComponent("v-usercontactdetailsv2")!
  const _component_v_usercontactdetailsv3 = _resolveComponent("v-usercontactdetailsv3")!
  const _component_v_usercontactdetailsv4 = _resolveComponent("v-usercontactdetailsv4")!
  const _component_v_usercontactdetailsv5 = _resolveComponent("v-usercontactdetailsv5")!
  const _component_v_usercontactdetailsv6 = _resolveComponent("v-usercontactdetailsv6")!
  const _component_v_usercontactdetailsv7 = _resolveComponent("v-usercontactdetailsv7")!
  const _component_v_userrelationship = _resolveComponent("v-userrelationship")!
  const _component_v_userrelationshipv2 = _resolveComponent("v-userrelationshipv2")!
  const _component_v_userrelationshipv4 = _resolveComponent("v-userrelationshipv4")!
  const _component_v_userrelationshipv5 = _resolveComponent("v-userrelationshipv5")!
  const _component_v_usercctvdetails = _resolveComponent("v-usercctvdetails")!
  const _component_v_usercctvdetailsv2 = _resolveComponent("v-usercctvdetailsv2")!
  const _component_v_usercctvdetailsv3 = _resolveComponent("v-usercctvdetailsv3")!
  const _component_v_usercctvdetailsv4 = _resolveComponent("v-usercctvdetailsv4")!
  const _component_v_usercctvdetailsv5 = _resolveComponent("v-usercctvdetailsv5")!
  const _component_v_userdocuments = _resolveComponent("v-userdocuments")!
  const _component_v_userdocumentsv2 = _resolveComponent("v-userdocumentsv2")!
  const _component_v_userdocumentsv4 = _resolveComponent("v-userdocumentsv4")!
  const _component_v_userdocumentsv6 = _resolveComponent("v-userdocumentsv6")!
  const _component_v_userdocumentsv7 = _resolveComponent("v-userdocumentsv7")!
  const _component_v_userdocumentsv8 = _resolveComponent("v-userdocumentsv8")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.addUserDetails && _ctx.addUserDetails(...args)), ["prevent"]))
    }, [
      (_ctx.initModel.modelErrors.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_ctx.isRequestAuthorized)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _hoisted_4,
                  _createElementVNode("p", null, [
                    _createElementVNode("strong", null, _toDisplayString(_ctx.getLocalTranslatedValue("validationtext.validationHeading")), 1)
                  ]),
                  _createElementVNode("ul", _hoisted_5, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.initModel.modelErrors, (error, index) => {
                      return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(error), 1))
                    }), 128))
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _hoisted_7,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.initModel.modelErrors, (error, index) => {
                    return (_openBlock(), _createElementBlock("div", { key: index }, _toDisplayString(error), 1))
                  }), 128))
                ]))
          ]))
        : _createCommentVNode("", true),
      (_ctx.isRequestAuthorized)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("p", null, [
              _createElementVNode("strong", null, _toDisplayString(_ctx.getLocalTranslatedValue("labeltext.completedByWarning")), 1)
            ]),
            _withDirectives(_createVNode(_component_v_usercontactdetails, {
              initModel: _ctx.initModel,
              newUser: _ctx.newUser
            }, null, 8, ["initModel", "newUser"]), [
              [_vShow, 
            !_ctx.isComponentVersionUpdateRequired(_ctx.childComponentSection.PartA)
          ]
            ]),
            _withDirectives(_createVNode(_component_v_usercontactdetailsv2, {
              initModel: _ctx.initModel,
              newUser: _ctx.newUser
            }, null, 8, ["initModel", "newUser"]), [
              [_vShow, 
            _ctx.isComponentVersionUpdateRequired(_ctx.childComponentSection.PartA) &&
            _ctx.userContactDetailsVersion == 2
          ]
            ]),
            _withDirectives(_createVNode(_component_v_usercontactdetailsv3, {
              initModel: _ctx.initModel,
              newUser: _ctx.newUser
            }, null, 8, ["initModel", "newUser"]), [
              [_vShow, 
            _ctx.isComponentVersionUpdateRequired(_ctx.childComponentSection.PartA) &&
            _ctx.userContactDetailsVersion == 3
          ]
            ]),
            _withDirectives(_createVNode(_component_v_usercontactdetailsv4, {
              initModel: _ctx.initModel,
              newUser: _ctx.newUser
            }, null, 8, ["initModel", "newUser"]), [
              [_vShow, 
            _ctx.isComponentVersionUpdateRequired(_ctx.childComponentSection.PartA) &&
            _ctx.userContactDetailsVersion == 4
          ]
            ]),
            _withDirectives(_createVNode(_component_v_usercontactdetailsv5, {
              initModel: _ctx.initModel,
              newUser: _ctx.newUser
            }, null, 8, ["initModel", "newUser"]), [
              [_vShow, 
            _ctx.isComponentVersionUpdateRequired(_ctx.childComponentSection.PartA) &&
            _ctx.userContactDetailsVersion == 5
          ]
            ]),
            _withDirectives(_createVNode(_component_v_usercontactdetailsv6, {
              initModel: _ctx.initModel,
              newUser: _ctx.newUser
            }, null, 8, ["initModel", "newUser"]), [
              [_vShow, 
            _ctx.isComponentVersionUpdateRequired(_ctx.childComponentSection.PartA) &&
            _ctx.userContactDetailsVersion == 6
          ]
            ]),
            _withDirectives(_createVNode(_component_v_usercontactdetailsv7, {
              initModel: _ctx.initModel,
              newUser: _ctx.newUser,
              styleCode: 
            _ctx.$route.query.Session?.toString() || _ctx.$route.query.session?.toString()
          
            }, null, 8, ["initModel", "newUser", "styleCode"]), [
              [_vShow, 
            _ctx.isComponentVersionUpdateRequired(_ctx.childComponentSection.PartA) &&
            _ctx.userContactDetailsVersion == 7
          ]
            ]),
            _withDirectives(_createVNode(_component_v_userrelationship, {
              initModel: _ctx.initModel,
              newUser: _ctx.newUser
            }, null, 8, ["initModel", "newUser"]), [
              [_vShow, 
            !_ctx.isComponentVersionUpdateRequired(_ctx.childComponentSection.PartB)
          ]
            ]),
            _withDirectives(_createVNode(_component_v_userrelationshipv2, {
              initModel: _ctx.initModel,
              newUser: _ctx.newUser
            }, null, 8, ["initModel", "newUser"]), [
              [_vShow, 
            _ctx.isComponentVersionUpdateRequired(_ctx.childComponentSection.PartB) &&
            _ctx.userCustEmpRelationshipVersion == 2
          ]
            ]),
            _withDirectives(_createVNode(_component_v_userrelationshipv4, {
              initModel: _ctx.initModel,
              newUser: _ctx.newUser
            }, null, 8, ["initModel", "newUser"]), [
              [_vShow, 
            _ctx.isComponentVersionUpdateRequired(_ctx.childComponentSection.PartB) &&
            _ctx.userCustEmpRelationshipVersion == 4
          ]
            ]),
            _withDirectives(_createVNode(_component_v_userrelationshipv5, {
              initModel: _ctx.initModel,
              newUser: _ctx.newUser,
              styleCode: 
            _ctx.$route.query.Session?.toString() || _ctx.$route.query.session?.toString()
          
            }, null, 8, ["initModel", "newUser", "styleCode"]), [
              [_vShow, 
            _ctx.isComponentVersionUpdateRequired(_ctx.childComponentSection.PartB) &&
            _ctx.userCustEmpRelationshipVersion == 5
          ]
            ]),
            _withDirectives(_createVNode(_component_v_usercctvdetails, {
              initModel: _ctx.initModel,
              newUser: _ctx.newUser
            }, null, 8, ["initModel", "newUser"]), [
              [_vShow, 
            !_ctx.isComponentVersionUpdateRequired(_ctx.childComponentSection.PartC)
          ]
            ]),
            _withDirectives(_createVNode(_component_v_usercctvdetailsv2, {
              initModel: _ctx.initModel,
              newUser: _ctx.newUser
            }, null, 8, ["initModel", "newUser"]), [
              [_vShow, 
            _ctx.isComponentVersionUpdateRequired(_ctx.childComponentSection.PartC) &&
            _ctx.userCCTVDetailsVersion == 2
          ]
            ]),
            _withDirectives(_createVNode(_component_v_usercctvdetailsv3, {
              initModel: _ctx.initModel,
              newUser: _ctx.newUser
            }, null, 8, ["initModel", "newUser"]), [
              [_vShow, 
            _ctx.isComponentVersionUpdateRequired(_ctx.childComponentSection.PartC) &&
            _ctx.userCCTVDetailsVersion == 3
          ]
            ]),
            _withDirectives(_createVNode(_component_v_usercctvdetailsv4, {
              initModel: _ctx.initModel,
              newUser: _ctx.newUser
            }, null, 8, ["initModel", "newUser"]), [
              [_vShow, 
            _ctx.isComponentVersionUpdateRequired(_ctx.childComponentSection.PartC) &&
            _ctx.userCCTVDetailsVersion == 4
          ]
            ]),
            _withDirectives(_createVNode(_component_v_usercctvdetailsv5, {
              initModel: _ctx.initModel,
              newUser: _ctx.newUser
            }, null, 8, ["initModel", "newUser"]), [
              [_vShow, 
            _ctx.isComponentVersionUpdateRequired(_ctx.childComponentSection.PartC) &&
            _ctx.userCCTVDetailsVersion == 5
          ]
            ]),
            _withDirectives(_createVNode(_component_v_userdocuments, {
              onShowValidationMessage: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showErrorMessageForFileUpload($event))),
              initModel: _ctx.initModel,
              newUser: _ctx.newUser
            }, null, 8, ["initModel", "newUser"]), [
              [_vShow, 
            !_ctx.isComponentVersionUpdateRequired(_ctx.childComponentSection.PartD)
          ]
            ]),
            _withDirectives(_createVNode(_component_v_userdocumentsv2, {
              onShowValidationMessage: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showErrorMessageForFileUpload($event))),
              initModel: _ctx.initModel,
              newUser: _ctx.newUser
            }, null, 8, ["initModel", "newUser"]), [
              [_vShow, 
            _ctx.isComponentVersionUpdateRequired(_ctx.childComponentSection.PartD) &&
            _ctx.userDocumentsVersion == 2
          ]
            ]),
            _withDirectives(_createVNode(_component_v_userdocumentsv4, {
              onShowValidationMessage: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showErrorMessageForFileUpload($event))),
              initModel: _ctx.initModel,
              newUser: _ctx.newUser
            }, null, 8, ["initModel", "newUser"]), [
              [_vShow, 
            _ctx.isComponentVersionUpdateRequired(_ctx.childComponentSection.PartD) &&
            _ctx.userDocumentsVersion == 4
          ]
            ]),
            _withDirectives(_createVNode(_component_v_userdocumentsv6, {
              onShowValidationMessage: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showErrorMessageForFileUpload($event))),
              initModel: _ctx.initModel,
              newUser: _ctx.newUser
            }, null, 8, ["initModel", "newUser"]), [
              [_vShow, 
            _ctx.isComponentVersionUpdateRequired(_ctx.childComponentSection.PartD) &&
            _ctx.userDocumentsVersion == 6
          ]
            ]),
            _withDirectives(_createVNode(_component_v_userdocumentsv7, {
              onShowValidationMessage: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showErrorMessageForFileUpload($event))),
              initModel: _ctx.initModel,
              newUser: _ctx.newUser
            }, null, 8, ["initModel", "newUser"]), [
              [_vShow, 
            _ctx.isComponentVersionUpdateRequired(_ctx.childComponentSection.PartD) &&
            _ctx.userDocumentsVersion == 7
          ]
            ]),
            _withDirectives(_createVNode(_component_v_userdocumentsv8, {
              onShowValidationMessage: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showErrorMessageForFileUpload($event))),
              initModel: _ctx.initModel,
              newUser: _ctx.newUser,
              styleCode: 
            _ctx.$route.query.Session?.toString() || _ctx.$route.query.session?.toString()
          
            }, null, 8, ["initModel", "newUser", "styleCode"]), [
              [_vShow, 
            _ctx.isComponentVersionUpdateRequired(_ctx.childComponentSection.PartD) &&
            _ctx.userDocumentsVersion == 8
          ]
            ]),
            _createElementVNode("button", {
              class: "button button--block",
              id: "submitSAR",
              type: "submit",
              disabled: _ctx.isDisabled
            }, _toDisplayString(_ctx.getLocalTranslatedValue("labeltext.submit")), 9, _hoisted_9)
          ]))
        : _createCommentVNode("", true)
    ], 32)
  ]))
}